<template>
  <svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <circle id="tbmzq8y6ea" cx="10.5" cy="10.5" r="10.71" />
    </defs>
    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
      <mask id="h6icr0t1lb" fill="#fff">
        <use xlink:href="#tbmzq8y6ea" />
      </mask>
      <use fill="#000" xlink:href="#tbmzq8y6ea" />
      <g fill="#FFF" fill-rule="nonzero" mask="url(#h6icr0t1lb)">
        <path
          d="M10.5 14.72c.99 0 1.847-.33 2.548-.98.7-.65 1.055-1.446 1.055-2.365 0-.92-.355-1.715-1.056-2.366-.7-.65-1.557-.98-2.547-.98-.99 0-1.847.33-2.547.98-.7.65-1.056 1.447-1.056 2.366 0 .92.355 1.715 1.056 2.366.7.65 1.557.98 2.547.98zM16.647 19.22a7.831 7.831 0 0 0-.12-.88 6.605 6.605 0 0 0-.23-.886 4.248 4.248 0 0 0-.387-.826 3.147 3.147 0 0 0-.583-.715 2.598 2.598 0 0 0-.838-.495 3.055 3.055 0 0 0-1.07-.183c-.15 0-.297.059-.579.232-.174.106-.377.23-.604.366a3.57 3.57 0 0 1-.78.324 3.279 3.279 0 0 1-.956.146c-.318 0-.639-.05-.956-.146a3.562 3.562 0 0 1-.78-.324 83.594 83.594 0 0 1-.605-.366c-.282-.173-.428-.232-.58-.232-.384 0-.744.062-1.069.183a2.596 2.596 0 0 0-.837.495c-.22.198-.417.439-.583.715-.161.267-.291.545-.387.826a6.62 6.62 0 0 0-.23.886c-.06.312-.1.609-.12.88-.02.268-.03.544-.03.824 0 .728.246 1.317.73 1.751.48.429 1.112.646 1.882.646h7.13c.77 0 1.403-.217 1.881-.646.485-.434.73-1.023.73-1.751 0-.281-.01-.558-.03-.823z" />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GoRateAvatar'
})
</script>
